<template>
    <div id="menu-footer-content">
        <div class="menu-mobile-intervencoes" @click="toggleMenu">
           <small>Você está vendo</small>
           <h3>{{ nomeSetor.nome }}</h3>
        </div>
        <div id="menu" v-if="menu">
            <ul>
                <li @click="alterarSetor(1)">
                    <img src="@/assets/norte-centro-oeste-nord-ocidental.png" alt="">
                    <p>Norte, Centro-Oeste e Nordeste Ocidental</p>
                </li>
                <li @click="alterarSetor(3)">
                    <img src="@/assets/nordeste-meridional.png" alt="">
                    <p>Nordeste Meridional</p>
                </li>
                <li @click="alterarSetor(2)">
                    <img src="@/assets/nordeste-setentorial.png" alt="">
                    <p>Nordeste e Setentrional</p>
                </li>
                <li @click="alterarSetor(4)">
                     <img src="@/assets/sudeste.png" alt="">
                    <p>Sudeste</p>
                </li>
                <li @click="alterarSetor(5)">
                    <img src="@/assets/sul.png" alt="">
                    <p>Sul</p>
                </li>
                <li @click="alterarSetor(6)">
                    <p>Todas as fichas resumo</p>
                    <img src="@/assets/arrow-right-corner.png" alt="">
                </li>

            </ul>
        </div>
    </div>
</template>


<script>
import { mapActions, mapState } from 'vuex'

export default {
    data () {
        return {
        setores: [
            {
            id: 1,
            nome: 'Brasil'
            },
            {
            id: 2,
            nome: 'Norte, Centro-Oeste e Nordeste Ocidental'
            },
            {
            id: 3,
            nome: 'Nordeste e Setentrional'
            },
            {
            id: 4,
            nome: 'Nordeste Meridional'
            },
            {
            id: 5,
            nome: 'Sudeste'
            },
            {
            id: 6,
            nome: 'Sul'
            },
            {
            id: 7,
            nome: 'Todas as fichas resumo'
            }
        ],
        menu: false
        }
    },

    computed: {
      ...mapState({
        'setorAtivo': state => state.Layout.setorAtivo
      }),

      nomeSetor () {
          return this.setores[this.setorAtivo - 1]
      }
    },

    methods: {
        ...mapActions({
            setSetorAtivo: 'Layout/setSetorAtivo'
        }),

        toggleMenu () {
            this.menu = !this.menu
            console.log(this.menu)
        },


        alterarSetor (setor) {
            this.menu = false;
            this.setSetorAtivo(this.setores[setor])
        }
    }
}
</script>


<style lang="scss" scoped>

#menu-footer-content {
    display: none;
    @include media_tablet() {
        display: block;
    }
}

.menu-mobile-intervencoes {
    position: absolute;
    bottom: 0px;
    background-color: #3994d0;
    height: 58px;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    small {
        color: #c9e2f3;
        font-size: 12px;
        margin-bottom: 5px;
    }

    h3 {
        color: #ffffff;
        font-size: 18px;
        font-family: 'rubik_bold';
        text-align: center;
    }
}

#menu {
    color: white;
    border: none;
    width: 100%;
    text-align: center;
    margin: auto;
    display: block;
    background-color: #1e618d;
    position: absolute;
    bottom: 58px;
    display: block;

    ul {
        li {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 84px;
            border-bottom: 1px solid #497b9c;
            &:nth-child(6) {
                background-color: #104466;
                border: none;
                height: 50px;
            }

            img {
                margin-right: 10px;
            }

            p {
                color: #fff;
                font-size: 16px;
                width: 160px;
                &:nth-child(6) {
                    width: 200px;
                }
            }
        }
    }
}
</style>
